import React, {  useRef,  useState, useEffect } from 'react';
import './SearchFilterSection.css';

import { handleChange } from '../../../../../components/helpers/latencyfunc.js';

import { filters_tmpl } from '../../data/filters.js'

import { countTrueValues, clearAllFields } from '../../../../../components/helpers/counttrueobj.js';
import { filterscountword } from '../../../../../components/helpers/wordsnumber.js';

import AddressFull from '../../../../cabinet/wizplain/components/Autocomplete/AddressFull.jsx';

import dictionarystreet from '../../../../cabinet/wizplain/data/addresses.json';

import '../../../../cabinet/wizplain/'


const SearchFilterSection = ({ isExpanded = false, onToggleFilters,  searchFilter, filters, setFilters, search}) => {
    
    const timeoutRefNear = useRef(null);

    const timeoutRefSearch = useRef(null);

    const [nearTxt, setNearTxt] = useState('');
    const [sTxt, setSearchTxt] = useState('');
        const [addressSearch, setAddressSearch] = useState({
            district: '',
            street: '',
            building: '',
            corpus: ''
        });
    



    const setGroupsFilter = (field, part)=>{
        const gr_obj = Object.assign({}, filters[part]);
        gr_obj[field] = !gr_obj[field];
        const outFilter = Object.assign({}, filters);
        outFilter[part] = gr_obj;
        setFilters(outFilter);
    }

    const nearAddress_ = (data)=>{
        const obj = { near: data, search: ""};
 
        setSearchTxt('');

        searchFilter(obj);
    }

    const searchFilter_ = (data)=>{
        const obj = { search: data, near: "", searchBy};
        setNearTxt('');
        searchFilter(obj);
    }


    const handleChangeNear = (e)=>{
        setNearTxt(e.target.value);
        handleChange(e, nearAddress_, timeoutRefNear)
    };

    const handleChangeSearch = (e)=>{
        const val = e.target.value;
        if(!val) return setSearchTxt("");
        setSearchTxt(val.replace(/\\/g, ''));
        handleChange(e, searchFilter_, timeoutRefSearch)
    };

    const handleChangeSearchBy = (e)=>{
      const val = e.target.value;
      searchFilter({ near: nearTxt, search: sTxt, searchBy: val});
    }


    const handleAddressChange = (field, value) => {
    setAddressSearch(prev => ({
        ...prev,
        [field]: value
    }));
    };
    


    useEffect(() => {
            return () => {
              if (timeoutRefNear.current) {
                clearTimeout(timeoutRefNear.current);
              }
            };
          }, []);

    useEffect(() => {
        return () => {
            if (timeoutRefSearch.current) {
            clearTimeout(timeoutRefSearch.current);
            }
        };
        }, []);

    const filtersCount = countTrueValues(filters);
    const filterword = filterscountword(filtersCount);
    const lineOpenFilter = filtersCount ? (['Застосовано ',filtersCount, filterword].join(" ")) : 'Фільтри не застосовані';


        // Визначаємо, які типи захворювань показувати
    const showDiseaseFilters = filters.specialization.combined || filters.specialization.sanatorium || filters.specialization.special;
    const showSanatoriumDiseases = filters.specialization.sanatorium || filters.specialization.combined;
    const showSpecialDiseases = filters.specialization.special || filters.specialization.combined;


    const { searchBy } = search;
   
  return (
    <div className="search-filter-section">
      <div className="search-container" style={{ alignItems: 'last baseline'}}>
        {false && <div className="search-field">
          <label htmlFor="search-nearby">Шукати поряд з вами</label>
          <input 
            type="text" 
            id="search-nearby" 
            placeholder="Введіть вашу адресу"
            onChange={handleChangeNear}
            value={nearTxt}
          />
        </div>}
        
        {false && <div className="separator">або</div>}
        
        { false && <div className="search-field">
          <label htmlFor="search-kindergarten">Шукати садочок</label>
          <input 
            type="text" 
            id="search-kindergarten" 
            placeholder="Введіть адресу чи номер садочку"
            value={sTxt}
            onChange={handleChangeSearch}
          />
        </div>}

        
        <div className="search-field">
          {true && <><label htmlFor="search-kindergarten">Шукати садочок</label><span></span></> }
      {//searchBy !== 'address' && (
 (               <input 
                    type="text" 
                    id="search-kindergarten" 
                    placeholder={
                        searchBy === 'number' ? 
                        "Введіть номер садочку" :
                        searchBy === 'name' ? 
                        "Введіть назву садочку" :
                        "Введіть адресу садочку"
                    }
                    value={sTxt}
                    onChange={handleChangeSearch}
                />
        )} 
        {//searchBy == 'address' && (
false && (
                <div className="address-search-fields" style={{ background: 'none', border: 'none'}}>
                    <AddressFull
                        value={addressSearch}
                        dictionary={dictionarystreet} // Потрібно передати словник з адресами
                        onChange={handleAddressChange}
                        error={{}}
                        fields={{ path: {
                            district: 'district',
                            street: 'street',
                            house: 'building',
                            corpus: 'corpus'
                        }}}
                        title=""
                    />
                </div>
            )}
        </div>


        <div className="search-field">
            {/* Радіокнопки для вибору типу пошуку */}
            <div className="search-type-radios">
                <label className="radio-label">
                    <input
                        type="radio"
                        name="searchBy"
                        value="number"
                        checked={searchBy === 'number'}
                        onChange={handleChangeSearchBy}
                    />
                    <span>за номером</span>
                </label>
                <label className="radio-label">
                    <input
                        type="radio"
                        name="searchBy"
                        value="name"
                        checked={searchBy === 'name'}
                        onChange={handleChangeSearchBy}
                    />
                    <span>за назвою</span>
                </label>
                <label className="radio-label">
                    <input
                        type="radio"
                        name="searchBy"
                        value="address"
                        checked={searchBy === 'address'}
                        onChange={handleChangeSearchBy}
                    />
                    <span>за адресою</span>
                </label>
            </div>
        </div>
        
        
        <div className="filter-link-container">
          {isExpanded ? (
            <div>
              <a href="" className="filter-link" onClick={(e)=>{e.preventDefault(); setFilters(clearAllFields(filters))}}>Скинути { filtersCount } { filterword }</a>
              <a href="" className="filter-link ml-2" onClick={(e)=>{ e.preventDefault() ;onToggleFilters()}}>Сховати</a>
            </div>
          ) : (
            <a href="" className="filter-link" onClick={(e)=>{ e.preventDefault() ;onToggleFilters()}}>{lineOpenFilter}</a>
          )}
        </div>
      </div>
      
      {isExpanded && (
        <div className="filters-expanded">
          <div className="filters-row">
            <div className="filter-column">
              <h5 className="filter-title">За типом групи</h5>
              <div className="filter-items-grid">
                { [0,1].map((e)=><div className="filter-items-column">
                    { filters_tmpl.type_group.slice(7*e, 7*e + 7).map((r,i)=>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" checked={filters.type_group[r.field]} onChange={()=>setGroupsFilter(r.field, 'type_group')} id={`group${i}`}/>
                            <label className="form-check-label" htmlFor={`group${i}`}>
                            {r.label}
                            <span className="form-check-sublabel">{r.sublabel}</span>
                            </label>
                        </div>
                    )}
                    </div>) }
    
                </div>
              
            </div>
            
            <div className="filter-column">
              <h5 className="filter-title">За районом</h5>
              <div className="filter-items-single">
                {filters_tmpl.distr.map((d,i)=>
                    <div className="form-check">
                  <input className="form-check-input" type="checkbox" checked={filters.distr[d.field]} onChange={()=>setGroupsFilter(d.field, 'distr')} id={`distr${i}`}/>
                  <label className="form-check-label" htmlFor={`distr${i}`} >{d.label}</label>
                </div>
                )}
              </div>
            </div>
            
            <div className="filter-column">
              <h5 className="filter-title">З вільними місцями</h5>
              <div className="filter-items-single">
                {filters_tmpl.free_places.map((d,i)=>
                    <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={filters.free_places[d.field]} onChange={()=>setGroupsFilter(d.field, 'free_places')} id={`avail${i}`}/>
                    <label className="form-check-label" htmlFor={`avail${i}`}>{d.label}</label>
                    </div>
                )}
              </div>
               <h5 className="filter-title">Спеціалізація</h5>
              <div className="filter-items-single">
                {filters_tmpl.specialization.map((d,i)=>
                    <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={filters.free_places[d.field]} onChange={()=>setGroupsFilter(d.field, 'specialization')} id={`special${i}`}/>
                    <label className="form-check-label" htmlFor={`avail${i}`}>{d.label}</label>
                    </div>
                )}
              </div>
                                      {/* Вид захворювання (умовно відображається) */}
                                      {showDiseaseFilters && (
                                          <div className="">
                                              <h5 className="filter-title">Вид захворювання</h5>
                                              <div className="filter-items-single disease-filters" >
                                                  {/* Санаторні захворювання */}
                                                  {showSanatoriumDiseases && filters_tmpl.disease_type.slice(0, 6).map((d, i) => (
                                                      <div className="form-check" key={`sanat${i}`}>
                                                          <input
                                                              className="form-check-input"
  
                                                              type="checkbox"
                                                              checked={filters.disease_type[d.field]}
                                                              onChange={() => setGroupsFilter(d.field, 'disease_type')}
                                                              id={`disease${i}`}
                                                          />
                                                          <label className="form-check-label" htmlFor={`disease${i}`}>
                                                              {d.label}
                                                          </label>
                                                      </div>
                                                  ))}
                                                  
                                                  {/* Спеціальні захворювання */}
                                                  {showSpecialDiseases && filters_tmpl.disease_type.slice(6).map((d, i) => (
                                                      <div className="form-check" key={`spec${i}`}>
                                                          <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              checked={filters.disease_type[d.field]}
                                                              onChange={() => setGroupsFilter(d.field, 'disease_type')}
                                                              id={`disease${i + 6}`}
                                                          />
                                                          <label className="form-check-label" htmlFor={`disease${i + 6}`}>
                                                              {d.label}
                                                          </label>
                                                      </div>
                                                  ))}
                                              </div>
                                          </div>
                                      )}
              
            </div>
            
            </div>
          </div>
      )}
    </div>
  );
};

export default SearchFilterSection;